<script setup lang="ts">
  import ModalDialog from '@/VueComponents/Modals/ModalDialog.vue';
  defineProps({
    numberOfUploadFiles: { type: Number, default: 0 },
    confirmationText: { type: String, default: '' }
  });
  const emit = defineEmits < { 'continue' }>();
  const visible = defineModel<boolean>({ default: false });

</script>

<template>
  <ModalDialog
    v-model="visible"
    :title="$localize('ConfirmResponseModalTitle')"
  >
    <template #default>
      <div>
        <strong> {{ $localize('UploadFolderSubmitConfirmMessage', { numberOfUploadFiles }) }}</strong>
      </div>
      <hr>
      <div class="mt-3">
        {{ confirmationText }}
      </div>
    </template>
    <template #footer>
      <button
        ref="closeBtn"
        class="btn btn-outline-secondary"
        @click="visible = false"
      >
        {{ $localize('Cancel') }}
      </button>
      <button
        class="btn btn-primary"
        @click="emit('continue')"
      >
        {{ $localize('Continue') }}
      </button>
    </template>
  </ModalDialog>
</template>
